module.exports = __webpack_public_path__ + "img/b1.054d279d.png";